import React from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import App from "./App";
import "./amplify"; // 👈 make sure Amplify.configure runs before anything else

const theme = extendTheme({
  colors: {
    brand: {
      900: "#000000",
      800: "#111111",
      700: "#222222",
      yellow: "#FFD600",
      yellowDark: "#FFC300",
    },
  },
  styles: {
    global: {
      body: {
        bg: "brand.900",
        color: "brand.yellow",
      },
    },
  },
  fonts: {
    heading: `'Inter', sans-serif`,
    body: `'Inter', sans-serif`,
  },
});

const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <ChakraProvider theme={theme}>
        <App />
      </ChakraProvider>
    </React.StrictMode>
  );
} else {
  throw new Error("Root element not found");
}
